import { render, staticRenderFns } from "./leifeng-orderlist.vue?vue&type=template&id=6dac959b&scoped=true&"
import script from "./leifeng-orderlist.vue?vue&type=script&lang=js&"
export * from "./leifeng-orderlist.vue?vue&type=script&lang=js&"
import style0 from "./leifeng-orderlist.vue?vue&type=style&index=0&id=6dac959b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac959b",
  null
  
)

export default component.exports